import React from "react";
import { Empty, Flex, Spin } from "antd";

export interface EmptyAndSpinProps {
  /** 是否加载中 */
  loading: boolean;
  /** 空状态描述 */
  description?: React.ReactNode;
  /** 自定义类名 */
  className?: string;
  /** 空状态额外内容 */
  emptyChildren?: React.ReactNode;
  /** 加载中提示文字 */
  loadingText?: string;
  /** 空状态图片 */
  emptyImage?: string;
}

type DocgenInfo = {
  displayName: string;
  description: string;
  props: Record<string, {
    name: string;
    required: boolean;
    description: string;
    type: { name: string; raw: string };
    defaultValue?: { value: string };
  }>;
};

type ComponentWithDocgen = React.FC<EmptyAndSpinProps> & { __docgenInfo?: DocgenInfo };

/** 空状态和加载状态组合组件 */
export const EmptyAndSpin: React.FC<EmptyAndSpinProps> = ({ 
  loading, 
  description = "暂无数据", 
  className, 
  emptyChildren,
  loadingText,
  emptyImage
}) => {
  if (loading) {
    return (
      <Flex
        className={`pt-10 w-full ${className || ''}`}
        align="center"
        justify="center"
        vertical
      >
        <Spin size="large" />
        {loadingText && <div className="mt-4 text-gray-500">{loadingText}</div>}
      </Flex>
    );
  }

  return (
    <Flex
      className={`pt-10 w-full ${className || ''}`}
      align="center"
      justify="center"
    >
      <Empty
        image={emptyImage}
        description={description}
        imageStyle={{ height: 180 }}
      >
        {emptyChildren}
      </Empty>
    </Flex>
  );
};

// 手动添加 docgen 信息
(EmptyAndSpin as ComponentWithDocgen).__docgenInfo = {
  displayName: "EmptyAndSpin",
  description: "空状态和加载状态组合组件",
  props: {
    loading: {
      name: "loading",
      required: true,
      description: "是否加载中",
      type: { name: "boolean", raw: "boolean" }
    },
    description: {
      name: "description",
      required: false,
      description: "空状态描述",
      type: { name: "ReactNode", raw: "React.ReactNode" },
      defaultValue: { value: '"暂无数据"' }
    },
    className: {
      name: "className",
      required: false,
      description: "自定义类名",
      type: { name: "string", raw: "string" }
    },
    emptyChildren: {
      name: "emptyChildren",
      required: false,
      description: "空状态额外内容",
      type: { name: "ReactNode", raw: "React.ReactNode" }
    },
    loadingText: {
      name: "loadingText",
      required: false,
      description: "加载中提示文字",
      type: { name: "string", raw: "string" }
    },
    emptyImage: {
      name: "emptyImage",
      required: false,
      description: "空状态图片",
      type: { name: "string", raw: "string" }
    }
  }
};
